import { useQuery } from "@tanstack/react-query";
import { getEventScheduler } from "../actions/getEventScheduler";

export const useGetEventScheduler = ({ eventSchedulerUid }: { eventSchedulerUid?: string }) => {
  return useQuery({
    queryKey: ["eventScheduler", eventSchedulerUid],
    queryFn: () => getEventScheduler({ eventSchedulerUid: eventSchedulerUid! }),
    enabled: !!eventSchedulerUid && eventSchedulerUid.trim() !== "", // Only fetch if eventSchedulerUid is provided and not empty
  });
};
